import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { InverseClearButton } from '#/shared/components/Styled';
import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import BaseSwapIcon from '#/shared/components/GeneratedIcons/trimet/SwapVertical';
import BaseCalendarIcon from '#/shared/components/GeneratedIcons/trimet/Calendar';
import BaseCogIcon from '#/shared/components/GeneratedIcons/trimet/Cog';
import BasePencilIcon from '#/shared/components/GeneratedIcons/trimet/Pencil';
import Button from '#/shared/components/Buttons';

export const TripRequestWrapper = styled.div`
  background-color: ${props => props.theme.inverseBackgroundColor2};
  color: ${props => props.theme.inverseFontColor1};
  height: 100%;
  width: 100%;
`;

export const TripRequestBody = styled.div`
  color: ${props => props.theme.inverseFontColor1};
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: ${DESKTOP_MIN_BREAK};
  padding: 0 15px;
  overflow-y: auto;
`;

export const TripRequestRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${props => (props.firstRow ? '10px 0' : '25px 0 0')};
`;
export const TripRequestEndpoints = styled.div`
  display: flex;
  align-items: center;
  padding-top: 20px;
`;

export const TripRequestRowColumnGrow = styled.div`
  margin-right: 10px;
  flex: 1;
  min-width: 0;
`;
export const TripRequestRowColumnShrink = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
`;

export const EndpointInput = styled.div`
  display: flex;
  padding: 0.2em 0;
  font-size: 1.8em;
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: ${props => props.theme.inverseFontColor2};
  color: ${props =>
    props.isFaded
      ? props.theme.primaryFontColorReverse
      : props.theme.inverseFontColor2};
`;

export const EndpointText = styled.span`
  flex: 1 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  width: 1px;
`;

export const EndpointButton = styled(InverseClearButton).attrs(props => ({
  role: 'link',
  [GTM_DATA_ATTRIBUTE]: props.dataGtm,
}))`
  min-width: 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  padding: 0;
  @media (any-hover: hover) {
    &:hover {
      background-color: transparent;
    }
    &:hover ${EndpointInput} {
      color: ${props => props.theme.primaryFontColorReverse};
    }
  }
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

export const EndpointIconColumn = styled.div.attrs({
  role: 'presentation',
})`
  flex: 0 0 30px;
  justify-content: center;
  display: flex;
  margin: 0 10px 0 -5px;
`;

export const EndpointContentColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const EndpointLabel = styled.div`
  flex: 1;
  font-size: 1.1em;
  text-transform: uppercase;
  color: ${props => props.theme.inverseFontColor2};
`;

export const TripOptionsLabel = styled.div`
  flex: 1;
  font-size: 0.9em;
  margin: 0 0.75em 0.25em;
  text-transform: uppercase;
  color: ${props => props.theme.inverseFontColor2};
`;

export const SmallInputButton = styled(InverseClearButton).attrs(props => ({
  [GTM_DATA_ATTRIBUTE]: props.dataGtm,
}))`
  flex: 0 0 35px;
  display: flex;
  justify-content: center;
`;

export const SwapEndpointButton = injectIntl(styled(SmallInputButton).attrs(
  ({ intl, disabled }) => ({
    title: disabled
      ? undefined
      : intl.formatMessage({ id: 'planner.swapbuttontooltip' }),
  })
)`
  opacity: ${props => props.theme.inactiveOpacity};
  @media (any-hover: hover) {
    &:hover {
      opacity: 1;
      background-color: transparent;
    }
  }
  &:disabled:hover {
    cursor: initial;
    opacity: ${props => props.theme.inactiveOpacity};
  }
`);

export const SwapIcon = styled(BaseSwapIcon).attrs(props => ({
  role: 'presentation',
  fill: props.theme.inverseFontColor1,
  width: 24,
  height: 24,
}))``;

export const SettingsButton = styled(InverseClearButton).attrs(props => ({
  [GTM_DATA_ATTRIBUTE]: props.dataGtm,
}))`
  margin: 0 10px;
  border: 1px solid ${props => props.theme.inverseFontColor2};
  border-radius: 5px;
  padding: 7px;
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.inverseButtonColor1};
    }
  }
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

export const SettingsButtonContentColumn = styled.div`
  flex: 1 1 auto;
`;

export const SettingsButtonPrimaryText = styled.div`
  font-size: 1.8em;
  white-space: pre-line;
`;

export const SettingsButtonSecondaryText = styled.div`
  font-size: 1.2em;
`;

export const SettingsButtonIconColumn = styled.div.attrs({
  role: 'presentation',
})`
  display: flex;
  flex: 0 0 10px;
  align-items: center;
  font-size: 1.5em;
`;

export const EditIcon = styled(BasePencilIcon).attrs(props => ({
  fill: props.theme.inverseFontColor1,
  width: 15,
  height: 25,
}))`
  margin-left: 0.5em;
`;

export const CalendarIcon = styled(BaseCalendarIcon).attrs(props => ({
  fill: props.theme.inverseFontColor1,
  width: 25,
  height: 25,
}))``;

export const CogIcon = styled(BaseCogIcon).attrs(props => ({
  fill: props.theme.inverseFontColor1,
  width: 25,
  height: 25,
}))``;

// TODO: Align submit button to column flex end -- this styling needs a little more work
export const TripRequestSpacer = styled(TripRequestRow)`
  flex: 1 1 auto;
  min-height: 80px;
`;

export const TripRequestFooter = styled(TripRequestRow)`
  justify-content: center;
  margin-bottom: 10px;
`;

export const PlanTripButton = styled(Button)`
  max-width: 250px;
`;
